document.addEventListener('DOMContentLoaded', () => {
  const quantityDropdowns = document.querySelectorAll('.quantity-dropdown');

  quantityDropdowns.forEach(dropdown => {
    const maxInventory = dropdown.dataset.variantInventory === 'unlimited' ? 20 : parseInt(dropdown.dataset.variantInventory, 10);

    // 現在のオプション値より多い場合、新しい値を追加
    for (let i = 1; i <= maxInventory; i++) {
      const optionExists = Array.from(dropdown.options).some(option => parseInt(option.value, 10) === i);
      if (!optionExists) {
        const option = document.createElement('option');
        option.value = i;
        option.textContent = i;
        dropdown.appendChild(option);
      }
    }

    dropdown.addEventListener('change', event => {
      const variantId = event.target.dataset.quantityVariantId;
      const newQuantity = parseInt(event.target.value, 10);
      const itemIndex = parseInt(event.target.dataset.index, 10);

      // Update quantity via cart API
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: newQuantity
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.errors) {
          showError(`Error updating quantity: ${data.errors}`);
        } else {
          const priceElement = document.querySelector(`#CartItem-${itemIndex} .price`);
          const newPrice = data.items.find(item => item.variant_id === parseInt(variantId, 10)).final_line_price;
          priceElement.textContent = Shopify.formatMoney(newPrice);

          // Optionally, refresh the entire cart summary
          updateCartTotals();
        }
      });
    });
  });

  function updateCartTotals() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.querySelector('.cart-total').textContent = Shopify.formatMoney(cart.total_price);
      });
  }

  function showError(message) {
    const errorElement = document.getElementById('cart-errors');
    if (errorElement) {
      errorElement.textContent = message;
    }
  }
  
});

/*
  【ページ反映処理】
  ブランドカタログ、およびギフト用オリジナル布袋の適用に成功した場合、合計金額の表示を更新します
    main-cart-footer.liquid
*/
function updateCartTotalsForGift() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Shopify object isn't available
      document.querySelector('#cart-total').textContent = `¥${(cart.total_price / 100).toLocaleString()}`;
    });
}

/*
  【オプション適用処理】
  ブランドカタログ、およびギフト用オリジナル布袋の適用処理を行います。

  ●処理内容
    ユーザー選択内容に基づいて、オプションの適用/削除処理を行います
     - value === "あり"の場合、カートに追加
     - それ以外の場合、カートから削除
  　
  ●処理箇所
    main-cart-items.liquid
    main-cart-footer.liquid
*/
async function optionApply(e) {
  const itemName = e.target.name,
    itemOption = e.target.dataset.option,
    value = e.target.value,
    itemId = e.target.dataset.option_id;

  // 処理中のラジオボタンとnameが一致するものを無効化(処理終了後に有効化)
  document.querySelectorAll(`[name="${itemName}"]`).forEach((el) => {
    el.setAttribute("disabled",true);
  });

  // 全てのラジオボタンの状態をリセット
  document.querySelectorAll(`[data-option="${itemOption}"][value="${value}"]`).forEach((el) => {
    el.checked = value;
  });

  if (value === "あり") {
    // カートに追加
    await fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const lineItem = cart.items.find(item => item.variant_id === parseInt(itemId));

      if (!lineItem) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(itemId),
            quantity: 1
          })
        })
        .then(response => {
          if (response.status === 422) {
            alert("在庫を超えて購入できませんでした。");
            document.querySelectorAll(`[data-option="${itemOption}"][value="なし"]`).forEach((el) => {
              el.checked = true;
              console.log("Fallback checked (なし):", el.id);
            });
          } else {
            // 更新に成功した場合、ページに反映
            updateCartTotalsForGift();
          }
        })
        .catch((error) => {
          alert("在庫を超えて購入できませんでした。");
          document.querySelectorAll(`[data-option="${itemOption}"][value="なし"]`).forEach((el) => {
            el.checked = true;
            console.log("Fallback checked (なし):", el.id);
          });
          console.error('Error:', error);
        });
      }
    });
  } else {
    // カートから削除
    await fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const lineItem = cart.items.find(item => item.variant_id === parseInt(itemId));

        if (lineItem) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: lineItem.key,
              quantity: 0
            })
          })
          .then(response => response.json())
          .then(data => {
            // 更新に成功した場合、ページに反映
            updateCartTotalsForGift();
          })
          .catch((error) => {
            showError(`Error updating quantity: ${data.errors}`);
          });
        }
      });
  }

  // 処理中のラジオボタンを有効にします
  document.querySelectorAll(`[name="${itemName}"]`).forEach((el) => {
    el.removeAttribute("disabled");
    console.log("Re-enabled:", el.id);
  });
}

/*
  【ページ表示時のブランドカタログ適用処理】
  選択状態に合わせて、ブランドカタログの反映処理を行います。
  カートが空の状態から商品を追加した場合、ブランドカタログ=必要の選択状態を反映します。

  ●背景
    ブランドカタログの初期値が「必要」となったため、ページ表示時に適用処理が必要
*/
document.addEventListener('DOMContentLoaded', () => {
  const selectedBrandCatalog = document.querySelector('input[name="ブランドカタログ"][value="あり"]'),
    initializedCart = localStorage.hasOwnProperty('initialized_cart');
  if(selectedBrandCatalog && initializedCart === true){
    selectedBrandCatalog.checked = true;
    selectedBrandCatalog.dispatchEvent(new Event('change'));
    localStorage.removeItem("initialized_cart");
  }
})